module.exports = __webpack_public_path__ + "img/stock0.71bf64c0.png";